// =======================================
// modules/newsCarousel.js
// トップページ NEWS カルーセル
// - 3セット複製済みのDOMを translateX() で中央寄せ
// - setInterval で自動送り
// - mouseenter で停止 / mouseleave で即次スライド＋ループ再開
// - prefers-reduced-motion 対応
// =======================================

export function initNewsCarousel() {
  var track = document.querySelector('.p-news__track');
  if (!track) return;

  var originalCount = parseInt(track.dataset.originalCount, 10);
  if (!originalCount || originalCount < 2) return;

  var items = Array.from(track.children);
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // 2nd set の先頭（最新記事）を初期中心に
  // items[0..N-1] = 1st set, items[N..2N-1] = 2nd set, items[2N..3N-1] = 3rd set
  // 初期 idx = N（2nd set の item[0] = 最新記事）
  // → 左隣は idx=N-1（1st set の item[N-1] = 最古記事）✓
  // → 右隣は idx=N+1（2nd set の item[1] = 2番目）✓
  var idx = originalCount;

  function calcOffset(i) {
    var wrap = track.parentElement;
    var wrapW = wrap.offsetWidth;
    var item = items[i];
    return wrapW / 2 - item.offsetLeft - item.offsetWidth / 2;
  }

  function go(i, animated) {
    if (!animated || reducedMotion) {
      track.style.transition = 'none';
    }
    track.style.transform = 'translateX(' + calcOffset(i) + 'px)';
    if (!animated || reducedMotion) {
      // reflow 強制 → transition 即時無効
      void track.offsetHeight;
      track.style.transition = '';
    }
  }

  // 初期位置（アニメなし）
  go(idx, false);

  if (reducedMotion) return;

  var SLIDE_MS = 800;  // CSS transition と一致させる
  var PAUSE_MS = 2000; // スライド後の停止時間
  var timer    = null;

  function step() {
    idx++;
    go(idx, true);
    // スライド完了後：3rd set に入ったら 2nd set へ無音ジャンプ
    setTimeout(function () {
      if (idx >= originalCount * 2) {
        idx -= originalCount;
        go(idx, false);
      }
    }, SLIDE_MS + 50);
  }

  function startTimer() {
    if (timer) return;
    timer = setInterval(step, SLIDE_MS + PAUSE_MS);
  }

  function stopTimer() {
    if (timer) { clearInterval(timer); timer = null; }
  }

  startTimer();

  // hover 中はスライダー停止
  // 解除時：待機なしで即スライド開始 → 以降は通常ループ
  var wrap = track.parentElement;
  wrap.addEventListener('mouseenter', stopTimer, { passive: true });
  wrap.addEventListener('mouseleave', function () {
    step();       // 解除直後に次のスライドを即時実行
    startTimer(); // 以降は SLIDE_MS + PAUSE_MS の通常ループ
  }, { passive: true });

  // リサイズ時に位置を再計算
  window.addEventListener('resize', function () {
    go(idx, false);
  }, { passive: true });
}
